<div class="modal_dialog shelf-selection-modal">
    <div class="modal_header">
        <h2>{{ 'Select Shelves for Product Storage' | translate }}</h2>
        <button class="btnn close_icon" type="button" (click)="onCancel()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="modal_body">
        <!-- Product Information -->
        <div class="product-info">
            <div class="product-details">
                <h3>{{ data.productName }}</h3>
                <p>{{ 'Vendor' | translate }}: {{ data.vendorName }}</p>
                <p>{{ 'Requested Quantity' | translate }}: {{ totalRequestedQuantity }}</p>
            </div>

            <div class="quantity-summary">
                <div class="quantity-item">
                    <span class="label">{{ 'Allocated' | translate }}:</span>
                    <span class="value allocated">{{ totalAllocatedQuantity }}</span>
                </div>
                <div class="quantity-item">
                    <span class="label">{{ 'Remaining' | translate }}:</span>
                    <span class="value remaining" [class.error]="remainingQuantity < 0">{{ remainingQuantity }}</span>
                </div>
                <div class="quantity-item">
                    <span class="label">{{ 'Status' | translate }}:</span>
                    <span class="value status" [class.complete]="isValidAllocation()"
                        [class.incomplete]="!isValidAllocation()">
                        {{ isValidAllocation() ? 'Complete' : 'Incomplete' }}
                    </span>
                </div>
            </div>
        </div>

        <!-- Filters -->
        <div class="filters-section">
            <div class="filters-header">
                <h4>{{ 'Filter Shelves' | translate }}</h4>
                <button type="button" class="btnn btn_outline_secondary clear-filters-btn" (click)="clearFilters()">
                    {{ 'Clear Filters' | translate }}
                </button>
            </div>

            <form [formGroup]="filterForm" class="filters-form">
                <div class="filter-group">
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>{{ 'Search Shelves' | translate }}</mat-label>
                        <input matInput formControlName="searchTerm"
                            placeholder="{{ 'SearchByShelfZoneLevel' | translate }}">
                    </mat-form-field>
                </div>

                <div class="filter-group">
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>{{ 'Filter by Zone' | translate }}</mat-label>
                        <mat-select formControlName="zone" (selectionChange)="onZoneChange()">
                            <mat-option value="">{{ 'All Zones' | translate }}</mat-option>
                            <mat-option *ngFor="let zone of zones" [value]="zone._id">
                                {{ zone.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="filter-group level-filter">
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>{{ 'Filter by Level' | translate }}</mat-label>
                        <mat-select formControlName="level">
                            <mat-option value="">{{ 'All Levels' | translate }}</mat-option>
                            <mat-option *ngFor="let level of getFilteredLevels()" [value]="level._id">
                                {{ level.level }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </form>
        </div>

        <!-- Loading State -->
        <div class="loading-state" *ngIf="loading">
            <div class="spinner"></div>
            <p>{{ 'Loading shelves...' | translate }}</p>
        </div>

        <!-- Suggested Shelves Section -->
        <ng-container *ngIf="!loading && filteredSuggestedShelves.length > 0">
            <ng-container *ngTemplateOutlet="shelvesSection; context: { 
                shelves: filteredSuggestedShelves, 
                title: 'SuggestedShelves', 
                isSuggested: true 
            }"></ng-container>
        </ng-container>

        <!-- All Available Shelves Section -->
        <ng-container *ngIf="!loading">
            <ng-container *ngTemplateOutlet="shelvesSection; context: { 
                shelves: filteredShelves, 
                title: 'AllAvailableShelves', 
                isSuggested: false 
            }"></ng-container>
        </ng-container>

        <!-- Shelves Template -->
        <ng-template #shelvesSection let-shelves="shelves" let-title="title" let-isSuggested="isSuggested">
            <div class="shelves-container">
                <div class="shelves-header">
                    <h4>{{ title | translate }} ({{ shelves.length }})</h4>
                </div>

                <div class="shelves-grid" *ngIf="shelves.length > 0">
                    <div class="shelf-card" 
                         *ngFor="let shelf of shelves; trackBy: trackByShelfId"
                         [class.selected]="shelf.isSelected"
                         [class.has-quantity]="shelf.allocatedQuantity && shelf.allocatedQuantity > 0"
                         (click)="onShelfSelect(shelf)">

                        <div class="shelf-content">
                            <div class="shelf-info">
                                <div class="shelf-header">
                                    <div class="shelf-name-container">
                                        <div class="shelf-name">{{ shelf.shelve }}</div>
                                        <div class="suggested-badge" *ngIf="isSuggestedShelf(shelf)">
                                            <mat-icon>lightbulb</mat-icon>
                                            <span>{{ getSuggestedQuantity(shelf) }}</span>
                                        </div>
                                    </div>
                                    <div class="shelf-selection-indicator">
                                        <mat-icon *ngIf="shelf.isSelected">check_circle</mat-icon>
                                        <mat-icon *ngIf="!shelf.isSelected">radio_button_unchecked</mat-icon>
                                    </div>
                                </div>

                                <div class="shelf-details">
                                    <div class="info-container">
                                        <div class="location-info">
                                            <div class="location-item">
                                                <small class="location-label">{{ 'Zone' | translate }}</small>
                                                <span class="zone">{{ shelf.zoneAbbreviation }}</span>
                                            </div>
                                            <div class="location-item">
                                                <small class="location-label">{{ 'Level' | translate }}</small>
                                                <span class="level">{{ shelf.levelName }}</span>
                                            </div>
                                        </div>
                                        <div class="shelf-stats" *ngIf="shelf.itemCount && shelf.itemCount > 0">
                                            <small class="items-count">{{ 'TotalItems' | translate }}: {{ shelf.itemCount }}</small>
                                        </div>

                                        <div class="shelf-stats" *ngIf="shelf.totalQuantity && shelf.totalQuantity > 0">
                                            <small class="items-count">{{ 'TotalQuantity' | translate }}: {{ shelf.totalQuantity }}</small>
                                        </div>
                                    </div>
                                    <div class="quantty-info">
                                        <div class="quantity-section" *ngIf="shelf.isSelected"
                                            (click)="$event.stopPropagation()">
                                            <div class="quantity-input-container">
                                                <button type="button" class="quantity-btn decrease"
                                                    (click)="decreaseQuantity(shelf)"
                                                    [disabled]="(shelf.allocatedQuantity || 0) <= 1">
                                                    <mat-icon>remove</mat-icon>
                                                </button>
                                                <input type="number" [value]="shelf.allocatedQuantity || 0"
                                                    (input)="onQuantityChange(shelf, +quantityInput.value)"
                                                    (keydown)="onQuantityKeyDown($event, shelf)"
                                                    (blur)="onQuantityBlur(shelf, quantityInput.value)" min="1"
                                                    [max]="remainingQuantity + (shelf.allocatedQuantity || 0)"
                                                    placeholder="0" class="quantity-input" #quantityInput>
                                                <button type="button" class="quantity-btn increase"
                                                    (click)="increaseQuantity(shelf)"
                                                    [disabled]="(shelf.allocatedQuantity || 0) >= (remainingQuantity + (shelf.allocatedQuantity || 0))">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </div>
                                            <div class="quantity-hint">
                                                <small *ngIf="!isQuantityExceeded(shelf)" class="hint-text">{{ 'MaxLabel' | translate }}: {{ remainingQuantity + (shelf.allocatedQuantity || 0) }}</small>
                                                <small *ngIf="isQuantityExceeded(shelf)" class="error-text">{{ 'ExceedsMaximumReqQuantity' | translate }}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Empty State -->
                <div class="empty-state" *ngIf="shelves.length === 0">
                    <mat-icon class="empty-icon">inventory_2</mat-icon>
                    <h4>{{ 'No shelves found' | translate }}</h4>
                    <p>{{ 'Try adjusting your filters or add more shelves to the system' | translate }}</p>
                </div>
            </div>
        </ng-template>

        <!-- Selected Shelves Summary -->
        <div class="selected-summary" *ngIf="selectedShelves.length > 0">
            <h4>{{ 'Selected Shelves' | translate }} ({{ selectedShelves.length }})</h4>
            <div class="selected-list">
                <div class="selected-item" *ngFor="let shelf of selectedShelves">
                    <div class="selected-info">
                        <span class="shelf-name">{{ shelf.shelve }}</span>
                        <span class="shelf-location">{{ shelf.zoneName }} - {{ shelf.levelName }}</span>
                    </div>
                    <div class="selected-quantity">
                        <span class="quantity">{{ shelf.allocatedQuantity }}</span>
                        <span class="unit">{{ 'units' | translate }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal_footer">
        <div class="action-buttons">
            <button class="btnn btn_secondary" type="button" (click)="onCancel()">
                {{ 'Cancel' | translate }}
            </button>
            <button class="btnn btn_primary" type="button" (click)="onSubmit()" [disabled]="!isValidAllocation()">
                {{ 'Allocate to Shelves' | translate }}
            </button>
        </div>
    </div>
</div>